export default function getKeyFromEvent(event) {
    const { key, keyCode, which } = event;
    return key || keyCode || which || 0;
}
